module.exports = ".modal-dialog {\n  width: 95%;\n  max-height: 95%;\n  max-width: none;\n  overflow-y: auto; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/account-client/component/account-client-details/proposal-view-modal/proposal-view-modal.component.scss
// module id = ./src/app/account-client/component/account-client-details/proposal-view-modal/proposal-view-modal.component.scss
// module chunks = main